/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class ContentLink extends Model {
  @attr() linkType;
  @attr() url;
}
